// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getFirestore } from "firebase/firestore";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional

const firebaseConfig = {
  apiKey: "AIzaSyBMWQ-qLH_kP1UkCGrx4N_DB3uVGvjDcZs",
  authDomain: "financialbreed.firebaseapp.com",
  projectId: "financialbreed",
  storageBucket: "financialbreed.appspot.com",
  messagingSenderId: "1029803040765",
  appId: "1:1029803040765:web:a64d72377663ec10608394",
  measurementId: "G-SBZB8NMZWQ"
};


// const firebaseConfig = {
//   apiKey: "AIzaSyBQZVvKad_BWMjLt-2oSJqijCqmY2WdBog",
//   authDomain: "financial-breed.firebaseapp.com",
//   projectId: "financial-breed",
//   storageBucket: "financial-breed.appspot.com",
//   messagingSenderId: "444122421195",
//   appId: "1:444122421195:web:1e97ee27c4eca174dc084e",
//   measurementId: "G-00JRF88116"
// };

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
export const db = getFirestore(app);